
import { useState } from "react";
import { Edit, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Pixel } from "./types";

interface PixelCardProps {
  pixel: Pixel;
  isSelected: boolean;
  onSelect: (pixel: Pixel) => void;
  onEdit: (pixel: Pixel) => void;
  onDelete: (pixel: Pixel) => void;
  canDelete: boolean;
}

export const PixelCard = ({ 
  pixel, 
  isSelected, 
  onSelect, 
  onEdit, 
  onDelete,
  canDelete
}: PixelCardProps) => {
  return (
    <div
      key={pixel.id}
      className={cn(
        "p-3 rounded-lg hover:bg-gray-100 group relative cursor-pointer",
        isSelected ? "bg-gray-100" : "bg-gray-50"
      )}
      onClick={() => onSelect(pixel)}
    >
      <h3 className="font-medium text-gray-800">{pixel.name}</h3>
      <p className="text-sm text-gray-500">{pixel.domain}</p>
      <div className="absolute right-2 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 flex gap-1">
        <Button
          variant="ghost"
          size="icon"
          className="hover:bg-blue-100 hover:text-blue-600 transition-opacity"
          onClick={(e) => {
            e.stopPropagation();
            onEdit(pixel);
          }}
        >
          <Edit className="h-4 w-4" />
        </Button>
        {canDelete && (
          <Button
            variant="ghost"
            size="icon"
            className="hover:bg-red-100 hover:text-red-600 transition-opacity"
            onClick={(e) => {
              e.stopPropagation();
              onDelete(pixel);
            }}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  );
};
